import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from "@/app";
import React from "react";
import { Navigate } from "react-router-dom";
export const ProtectedRoute = ({ children, requireAuth = false, }) => {
    const { isAuthenticated, isGuest, isLoading } = useAuth();
    // Пока идёт первичная проверка авторизации — НЕ редиректим. Возврат с оплаты
    // (и любая защищённая страница) открывается полной перезагрузкой, где на
    // первых кадрах isAuthenticated и isGuest ещё false; без этой проверки
    // /payment/success успевал улететь на "/" → /generate-song ДО того, как
    // смонтируется PaymentSuccessPage, и резюм создания песни после оплаты
    // терялся. Рендерим детей — они сами работают по cookie-сессии.
    if (isLoading) {
        return children;
    }
    // Гостевой чекаут: гость — полноценный пользователь (может покупать/платить),
    // поэтому пускаем в приложение по «авторизован ИЛИ гость».
    if (requireAuth && !isAuthenticated && !isGuest) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return children;
};
